<template>
  <div class="H5phone">
    <van-nav-bar>
      <van-button slot="left" icon="arrow-left" size="small" @click="onClickLeft" type="info"/>
    </van-nav-bar>
    <div class="H5phone-bg">
      <span @click="onReplace('bg')">背景图片</span>
      <van-button size="mini" type="primary" @click="saveNodePage">保存</van-button>
      <van-button size="mini" type="primary" @click="saveNodePage(gotoa)">发送</van-button>
      <span @click="getBjMusic">背景音乐</span>
    </div>
    <div class="page" ref="page">
      <div class="page-left">
        <van-icon name="arrow-left" @click="onLeft" v-if="realIndex !==0"/>
      </div>
      <div class="page-content" ref="pageContent">
        <div id="h5-arrow" ref="previewPages"
             :style="{margin:'0 auto','transform':`scale(${zoom}) translate(${x / zoom}px, ${y / zoom}px)`,width:width + 'px',height: height + 'px','transform-origin': `0 0`}">
          <PageItem :activeId="activeId" ref="PageItem" :zoom="zoom" :pageBg="previewPages.pageList[realIndex].pageBg"
                    :page="previewPages.pageList[realIndex].node" :x="x" :y="y"></PageItem>
        </div>
      </div>
      <div class="page-right">
        <van-icon name="arrow" @click="onRight"
                  v-if="this.previewPages.pageList.length - 1 !==realIndex"/>
      </div>
    </div>
    <div class="edit">
      <van-tabs v-model="active">
        <van-tab :title="'文字(' + fonts.length + ')'">
          <div class="fonts">
            <div v-for="(item,index) in fonts" class="fonts-item" :key="item.id" @click="setActiveId(item.id,index)">
              <nut-textbox :limitShow="false" v-model="item.content"></nut-textbox>
            </div>
          </div>
        </van-tab>
        <van-tab :title="'图片(' + imgs.length + ')'">
          <div class="imgs">
            <div v-for="(item,index) in imgs" class="imgs-item" :key="item.id" @click="setActiveId(item.id,index)">
              <div class="item-btn" v-if="item.id === activeId">
                <van-button type="danger" size="mini">删除</van-button>
                <van-button type="primary" size="mini" @click="onReplace('img')">替换</van-button>
              </div>
              <img :src="item.url" alt=""/>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <van-popup
        v-model="show"
        closeable
        position="bottom"
        :style="{ height: '70%' }">
      <div class="musics">
        <ul v-if="musics.length">
          <li @click="setBjMusics(item)" v-for="item in musics" :key="item.id">
            <van-icon name="music-o" style="margin-right: 5px"/>
            {{ item.name }}
          </li>
        </ul>
        <van-empty description="暂无数据" v-else/>
      </div>
    </van-popup>
    <addImages v-if="imgList" @setImages="setImages" @close="close"></addImages>
    <addvideos v-if="videoList" @setImages="setImages"></addvideos>
  </div>
</template>

<script>
import {mapState} from "vuex"
import qs from "qs";
import PageItem from "./phone/PageItem";
import addImages from "@/components/h5/addImages";
import cloneDeep from "lodash/cloneDeep";
import html2canvas from "html2canvas";
import {dataURLtoFile} from "../utils/switchingMode";
import {Toast} from "vant";

export default {
  name: "Phone",
  components: {PageItem, addImages},
  data() {
    return {
      x: 0,
      y: 0,
      zoom: 1,
      realIndex: 0,
      active: 0,
      imgs: [],
      videos: [],
      fonts: [],
      activeId: "",
      imgList: false,
      videoList: false,
      index: 0,
      getIndex: null,
      type: "img",
      show: false,
      musics: [],
      prmgremMsg: []
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    transitionEnd() {
      this.$nextTick(() => {
        const realIndex = this.$refs['swiperOption'].$swiper ? this.$refs['swiperOption'].$swiper.realIndex : 0
        if (realIndex === this.realIndex) {
          return
        }
        this.realIndex = realIndex
      })
    },
    // 获取场景列表
    async getSceneList() {
      await this.$ajax.post("/etv/selectProgramMouldSceneInfo.json", qs.stringify({pmId: this.$route.params.id})).then(res => {
        if (res.data.code === 0) {
          this.$store.state.width = parseInt(res.data.data[0].resolution.split("*")[0])
          this.$store.state.height = parseInt(res.data.data[0].resolution.split("*")[1])
          this.$store.state.scId = res.data.data[0].scId
          this.prmgremMsg = res.data.data
        }
      })
    },
    // 获取场景
    async getSceneData(parame, scId) {
      await this.$ajax.post("/etv/selectSceneInfo.json", qs.stringify({
        pmId: this.$route.params.id,
        scId: scId
      })).then(res => {
        if (res.data.code === 0) {
          this.$store.state.previewPages = JSON.parse(res.data.data.componentsList[0].txList[0].taAddress)
          this.imgs = []
          this.videos = []
          this.fonts = []
          this.previewPages.pageList[this.realIndex].node.map(res => {
            if (res.type === 'img') {
              this.imgs.push(res)
            } else if (res.type === 'video') {
              this.videos.push(res)
            } else {
              this.fonts.push(res)
            }
          })
        }
      })
    },
    onClickLeft() {
      this.$router.back()
    },
    async init() {
      await this.getSceneList(this.$route.params)
      await this.getSceneData(this.$route.params, this.scId)
      this.$nextTick(() => {
        const phoneWidth = this.$refs['pageContent'].clientWidth
        const phoneHeight = this.$refs['pageContent'].clientHeight

        if (phoneWidth / phoneHeight < this.width / this.height) {
          this.zoom = phoneWidth / this.width
        } else {
          this.zoom = phoneHeight / this.height
        }

        const w = document.getElementById('h5-arrow').clientWidth * this.zoom
        const h = document.getElementById('h5-arrow').clientHeight * this.zoom


        if (phoneWidth / phoneHeight < this.width / this.height) {
          this.x = 0
          this.y = (phoneHeight - h) / 2
        } else {
          this.x = (phoneWidth - w) / 2
          this.y = 0
        }


      })
    },
    onLeft() {
      this.realIndex--
      if (this.realIndex === 0) {
        this.realIndex = 0
      }
    },
    close() {
      this.imgList = false
    },
    onRight() {
      this.realIndex++
      if (this.realIndex === this.previewPages.pageList.length - 1) {
        this.realIndex = this.previewPages.pageList.length - 1
      }
    },
    setActiveId(activeId, index) {
      this.index = index
      this.activeId = activeId
    },
    onReplace(type) {
      this.type = type
      this.imgList = true
    },
    setImages(data) {
      this.imgList = false
      if (this.type === 'img') {
        this.imgs.splice(this.index, 1, data[0])
        this.previewPages.pageList[this.realIndex].node.forEach((res, index) => {
          if (res.id === this.activeId) {
            this.getIndex = index
          }
        })
        this.previewPages.pageList[this.realIndex].node[this.getIndex].url = this.upFileUrl + data[0].url
        this.$set(this.previewPages.pageList[this.realIndex].node, this.getIndex, this.previewPages.pageList[this.realIndex].node[this.getIndex])
      } else if (this.type === 'bg') {
        this.previewPages.pageList[this.realIndex].pageBg = this.upFileUrl + data[0].url
      }
    },
    gotoa(url, query) {
      this.$router.push({
        path: url,
        query,
      })
    },
    async saveNodePage(callback) {
      this.$store.state.isSave = true
      const copyPages = cloneDeep(this.previewPages)
      copyPages.pageList.forEach(item => {
        item.node.forEach(res => {
          res.infoHeight = res.infoHeightDr
          res.infoWidth = res.infoWidthDr
          res.infoLeft = res.infoLeftDr
          res.infoTop = res.infoTopDr
        })
      })
      let form = new FormData()
      let obj = {}

      obj.pmId = this.$route.params.id
      obj.backImg = ""
      obj.backImgId = ""
      obj.backImgSize = ""
      obj.scTime = "0"
      obj.sort = 1
      obj.scId = this.scId
      obj.scName = "test"
      obj.type = "4"
      obj.html = "hello word"
      obj.isSaveBtn = true
      obj.compents = [
        {
          "type": "webPage",
          "leftPosition": 0,
          "rightPosition": 0,
          "width": this.width,
          "height": this.height,
          "actionType": 1,
          "linkAction": 1,
          "screenProtectTime": "10",
          "materials": [{
            "color": "#fff", // 颜色
            "content": `http://192.168.1.56:8080/web/#/previewh5/${this.$route.params.id.id}`, // 内容
            "fontSize": "36", // 长度
            "move": '1', // 滚动方向
            "no": 1, // 序号
            "alignment": 1, // 对齐方式
            "bgColor": "#fff", // 字幕背景色
            "moveSpeed": 1, // 字幕滚动速度
            "difference": 2, // 属性控件 字幕、天气、日期等控件
            "address": JSON.stringify(copyPages), // 地址
            "countDown": "res.taCountDown"
          }],
        }
      ]

      await html2canvas(this.$refs.previewPages, {
        backgroundColor: null     // 解决生成的图片有白边
      }).then((canvas) => {
        let jietu = canvas.toDataURL("image/jpeg")
        const result = dataURLtoFile(jietu, 'test.jpeg')
        form.append("scenenJsonStr", JSON.stringify(obj))
        form.append("files", result)
      }).catch(err => {
        console.error(err)
      })

      await this.$ajax({
        url: "/etv/insertSceneInfo.json",
        method: 'post',
        header: {
          'Content-Type': 'multipart/form-data'
        },
        data: form
      }).then(res => {
        this.$store.state.isSave = false
        if (res.data.code === 0) {
          Toast(res.data.msg);
          callback && callback(`/addTask`, {
            grogramIds: this.$route.params.id,
            parentPage: 'taskList',
            progremData: this.prmgremMsg
          })
        }
      })
    },
    getBjMusic() {
      this.$ajax.post("/etv/selectAllAudio.json").then(res => {
        if (res.data.code === 0) {
          this.musics = res.data.data
          this.show = true
        }
      })
    },
    setBjMusics(data) {
      this.previewPages.setting.musicUrl = this.upFileUrl + data.url
      this.previewPages.setting.musicName = data.name
      this.show = false
    },
  },
  watch: {
    realIndex(newVal) {
      this.imgs = []
      this.videos = []
      this.fonts = []
      this.previewPages.pageList[newVal].node.map(res => {
        if (res.type === 'img') {
          this.imgs.push(res)
        } else if (res.type === 'video') {
          this.videos.push(res)
        } else {
          this.fonts.push(res)
        }
      })
    }
  },
  computed: {
    ...mapState({
      pageIndex: state => state.pageIndex,
      scId: state => state.scId,
      previewPages: state => state.previewPages,
      width: state => state.width,
      height: state => state.height,
    }),
  },
}
</script>

<style lang="scss">
.musics {
  height: 100%;
  padding-top: 50px;
  box-sizing: border-box;
  overflow: auto;


  ul {
    padding: 0 15px;

    li {
      height: 30px;
      display: flex;
      align-items: center;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

.H5phone {
  height: 100%;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  flex-direction: column;
  .van-button--small {
    min-width: 10px !important;
    .van-icon{
      color: white;
    }
  }
  .H5phone-bg {
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .swiper-wrapper {
    display: block;
  }

  .page {
    height: 300px;
    background: burlywood;
    box-sizing: border-box;
    width: 100%;
    overflow: hidden;

    .page-content {
      width: calc(100% - 40px);
      height: 100%;
      float: left;
      background: burlywood;
    }

    .page-left, .page-right {
      width: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
    }

    .page-left {
      float: left;
    }

    .page-right {
      float: right;
    }
  }

  .edit {
    height: calc(100% - 384px);

    .van-tabs {
      height: 100%;

      .van-tabs__content {
        height: calc(100% - 44px);

        .van-tab__pane {
          height: 100%;

          .imgs {
            height: 100%;
            width: 100%;
            overflow: auto;
            padding: 10px;
            box-sizing: border-box;
            display: flex;
            flex-wrap: wrap;

            .imgs-item {
              width: 50%;
              padding: 10px;
              height: 120px;
              box-sizing: border-box;
              position: relative;

              .item-btn {
                position: absolute;
                top: 10px;
                left: 10px;
                bottom: 10px;
                right: 10px;
                background: rgba(0, 0, 0, .3);
                display: flex;
                align-items: flex-end;
                justify-content: center;
              }

              img {
                width: 100%;
                height: 100%;
              }
            }
          }

          .fonts {
            height: 100%;
            width: 100%;
            overflow: auto;
            box-sizing: border-box;
            display: flex;
            flex-wrap: wrap;

            .nut-textbox {
              height: 100%;

              .txt-area {
                height: 100%;

                textarea {
                  height: 100% !important;
                  background: #f1f1f1;
                }
              }
            }

            .fonts-item {
              width: 100%;
              padding: 10px;
              height: 100px;
              box-sizing: border-box;
              position: relative;

              .item-btn {
                position: absolute;
                top: 10px;
                left: 10px;
                bottom: 10px;
                right: 10px;
                background: rgba(0, 0, 0, .3);
                display: flex;
                align-items: flex-end;
                justify-content: center;
              }

              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }
  }
}
</style>
